<template>
    <v-container>
        <v-row class="mt-5">
            <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3">
                <login-card @success="onLoginSuccess"/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LoginCard from "@/components/entrance/LoginCard";

export default {
    components: {
        LoginCard
    },
    computed: {
        slug(vm = this) {
            return vm.$route.query.slug || null
        }
    },
    methods: {
        onLoginSuccess() {
            const vm = this
            console.log('login success', vm.currentUser)

            if (vm.isPatient && (vm.currentUser?.status_id === 1 || vm.slug)) {
                let query = {}
                if (vm.slug) query.slug = vm.slug
                return vm.$router.push({name: 'client.stepper', query: query})
            }

            return vm.$router.push({name: 'home'})
        },
    },
}
</script>

<style scoped>

</style>
